import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import type { JobSchedulerError } from '@core/offers-types';
import { RtTooltip } from '@core/user-interface-legacy';

import { JobSchedulerErrorTextsService } from './job-scheduler-error-texts.service';

@Component({
  selector: 'rt-job-scheduler-error',
  imports: [RtTooltip],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <span [rtTooltip]="errorTooltip" [rtTooltipHasTextAlignCenter]="true" text-red>
      {{ errorContent }}
    </span>
  `,
})
export class JobSchedulerErrorComponent {
  private readonly textsService = inject(JobSchedulerErrorTextsService);

  public readonly schedulerError = input<JobSchedulerError | null>();

  public get errorContent() {
    const schedulerError = this.schedulerError();
    return schedulerError ? this.textsService.errorTexts[schedulerError]?.content : '';
  }

  public get errorTooltip() {
    const schedulerError = this.schedulerError();
    return schedulerError ? this.textsService.errorTexts[schedulerError]?.tooltip : '';
  }
}
